import type { AnimalHealthRecord } from './animal-health-record.interface';
import type { TaskInstance } from './task-instance.interface';

export interface TaskAnimalHealthRecord {
    AnimalHealthRecord: AnimalHealthRecord;
    C_Material_key: number;
    C_TaskAnimalHealthRecord_key: number;
    C_TaskInstance_key: number;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    JobName: string;
    ModifiedBy: string;
    Sequence: number;
    TaskInstance: TaskInstance;
    Version: number;
}
